<template>
  <b-container fluid class="p-0">
    <b-row class="m-0">
      <b-col xl="6" lg="12" v-if="cancelled_context_loaded" class="pr-2 pb-4 pl-2">
        <b-container fluid class="white-box text-base">
          <b-row align-h="center" class="text-16">Cancelado</b-row>
          <b-row align-h="center" style="text-align: center" class="text-24">
            {{ cancelled_len_0 }} pedidos - {{ cancelled_sum_0 }}
          </b-row>
          <highcharts :options="chartOptionsCancelled"></highcharts>
          <no-data v-if="cancelled_methods_data_0.length < 1"/>
        </b-container>
      </b-col>
      <b-col v-else xl="6" lg="12" class="pr-2 pb-4 pl-2">
        <loader-box height="408px"/>
      </b-col>

      <b-col xl="6" lg="12" v-if="cancelled_context_loaded" class="pr-2 pb-4 pl-2">
        <b-container fluid class="white-box text-base">
          <b-row align-h="center" class="text-16">Não autorizado pela Adquirente</b-row>
          <b-row align-h="center" style="text-align: center" class="text-24">
            {{ cancelled_len_1 }} pedidos - {{ cancelled_sum_1 }}
          </b-row>
          <highcharts :options="chartOptionsCreditCardUnauthorized"></highcharts>
          <no-data v-if="cancelled_methods_data_1.length < 1"/>
        </b-container>
      </b-col>
      <b-col v-else xl="6" lg="12" class="pr-2 pb-4 pl-2">
        <loader-box height="408px"/>
      </b-col>
    </b-row>

    <b-row class="m-0">
      <b-col xl="6" lg="12" v-if="cancelled_context_loaded" class="pr-2 pb-4 pl-2">
        <b-container fluid class="white-box text-base">
          <b-row align-h="center" class="text-16">Estornado parcialmente</b-row>
          <b-row align-h="center" style="text-align: center" class="text-24">
            {{ cancelled_len_2 }} pedidos - {{ cancelled_sum_2 }}
          </b-row>
          <highcharts :options="chartCreditCardChargebackPartiallyMethodsData"></highcharts>
          <no-data v-if="cancelled_methods_data_2.length < 1"/>
        </b-container>
      </b-col>
      <b-col v-else xl="6" lg="12" class="pr-2 pb-4 pl-2">
        <loader-box height="408px"/>
      </b-col>

      <b-col xl="6" lg="12" v-if="cancelled_context_loaded" class="pr-2 pb-4 pl-2">
        <b-container fluid class="white-box text-base">
          <b-row align-h="center" class="text-16">Estornado valor total</b-row>
          <b-row align-h="center" style="text-align: center" class="text-24">
            {{ cancelled_len_3 }} pedidos - {{ cancelled_sum_3 }}
          </b-row>
          <highcharts :options="chartCreditCardChargebackTotalMethodsData"></highcharts>
          <no-data v-if="cancelled_methods_data_3.length < 1"/>
        </b-container>
      </b-col>
      <b-col v-else xl="6" lg="12" class="pr-2 pb-4 pl-2">
        <loader-box height="408px"/>
      </b-col>
    </b-row>

    <b-row class="m-0">
      <b-col xl="6" lg="12" v-if="cancelled_context_loaded" class="pr-2 pb-4 pl-2">
        <b-container fluid class="white-box text-base">
          <b-row align-h="center" class="text-16">Pedido vencido</b-row>
          <b-row align-h="center" style="text-align: center" class="text-24">
            {{ cancelled_len_4 }} pedidos - {{ cancelled_sum_4 }}
          </b-row>
          <highcharts :options="chartCancelOverdueMethodsData"></highcharts>
          <no-data v-if="cancelled_methods_data_4.length < 1"/>
        </b-container>
      </b-col>
      <b-col v-else xl="6" lg="12" class="pr-2 pb-4 pl-2">
        <loader-box height="408px"/>
      </b-col>

      <b-col xl="6" lg="12" v-if="cancelled_context_loaded" class="pr-2 pb-4 pl-2">
        <b-container fluid class="white-box text-base">
          <b-row align-h="center" class="text-16">Cancelado por troca ou devolução</b-row>
          <b-row align-h="center" style="text-align: center" class="text-24">
            {{ cancelled_len_5 }} pedidos - {{ cancelled_sum_5 }}
          </b-row>
          <highcharts :options="chartCancelExchangeOrReturnMethodsData"></highcharts>
          <no-data v-if="cancelled_methods_data_5.length < 1"/>
        </b-container>
      </b-col>
      <b-col v-else xl="6" lg="12" class="pr-2 pb-4 pl-2">
        <loader-box height="408px"/>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import LoaderBox from '@/components/LoaderBox.vue'
import NoData from '@/components/NoData.vue'

export default {
  components: {
    LoaderBox,
    NoData
  },
  computed: {
    cancelled_sum_0() { return this.$store.getters.cancelled_sum_0 },
    cancelled_sum_1() { return this.$store.getters.cancelled_sum_1 },
    cancelled_sum_2() { return this.$store.getters.cancelled_sum_2 },
    cancelled_sum_3() { return this.$store.getters.cancelled_sum_3 },
    cancelled_sum_4() { return this.$store.getters.cancelled_sum_4 },
    cancelled_sum_5() { return this.$store.getters.cancelled_sum_5 },
    cancelled_len_0() { return this.$store.getters.cancelled_len_0 },
    cancelled_len_1() { return this.$store.getters.cancelled_len_1 },
    cancelled_len_2() { return this.$store.getters.cancelled_len_2 },
    cancelled_len_3() { return this.$store.getters.cancelled_len_3 },
    cancelled_len_4() { return this.$store.getters.cancelled_len_4 },
    cancelled_len_5() { return this.$store.getters.cancelled_len_5 },

    cancelled_context_loaded() { return this.$store.getters.cancelled_context_loaded },
    cancelled_methods_data_0() { return this.$store.getters.cancelled_methods_data_0 },
    cancelled_methods_data_1() { return this.$store.getters.cancelled_methods_data_1 },
    cancelled_methods_data_2() { return this.$store.getters.cancelled_methods_data_2 },
    cancelled_methods_data_3() { return this.$store.getters.cancelled_methods_data_3 },
    cancelled_methods_data_4() { return this.$store.getters.cancelled_methods_data_4 },
    cancelled_methods_data_5() { return this.$store.getters.cancelled_methods_data_5 },

    chartOptionsCancelled() {
      const cancelledMethodsData = this.cancelled_methods_data_0;
      const cancelledMethodsDrilldownSeries = this.$store.getters.cancelled_methods_drilldown_series_0;
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: 'clique para ver detalhes'
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f}%'
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> do total<br/>'
        },
        series: [
          {
            name: "Método",
            colorByPoint: true,
            data: cancelledMethodsData
          }
        ],
        drilldown: {
          series: cancelledMethodsDrilldownSeries
        },
      }
    },
    chartOptionsCreditCardUnauthorized() {
      const creditCardUnauthorizedMethodsData = this.cancelled_methods_data_1;
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f}%'
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> do total<br/>'
        },
        series: [{
          name: "Métodos",
          colorByPoint: true,
          data: creditCardUnauthorizedMethodsData
        }],
      }
    },
    chartCreditCardChargebackPartiallyMethodsData() {
      const creditCardChargebackPartiallyMethodsData = this.cancelled_methods_data_2;
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f}%'
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> do total<br/>'
        },
        series: [{
          name: "Método",
          colorByPoint: true,
          data: creditCardChargebackPartiallyMethodsData
        }],
      }
    },
    chartCreditCardChargebackTotalMethodsData() {
      const creditCardChargebackTotalMethodsData = this.cancelled_methods_data_3;
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f}%'
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> do total<br/>'
        },
        series: [{
          name: "Métodos",
          colorByPoint: true,
          data: creditCardChargebackTotalMethodsData
        }],
      }
    },
    chartCancelOverdueMethodsData() {
      const cancelOverdueMethodsData = this.cancelled_methods_data_4;
      const cancelOverdueMethodsDrilldownSeries = this.$store.getters.cancelled_methods_drilldown_series_4;
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: 'clique para ver detalhes'
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f}%'
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> do total<br/>'
        },
        series: [{
          name: "Método",
          colorByPoint: true,
          data: cancelOverdueMethodsData
        }],
        drilldown: {
          series: cancelOverdueMethodsDrilldownSeries
        },
      }
    },
    chartCancelExchangeOrReturnMethodsData() {
      const cancelExchangeOrReturnMethodsData = this.cancelled_methods_data_5;
      const cancelExchangeOrReturnMethodsDrilldownSeries = this.$store.getters.cancelled_methods_drilldown_series_5;
      return {
        chart: {
          type: 'pie'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: 'clique para ver detalhes'
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.percentage:.1f}%'
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> do total<br/>'
        },
        series: [{
          name: "Métodos",
          colorByPoint: true,
          data: cancelExchangeOrReturnMethodsData
        }],
        drilldown: {
          series: cancelExchangeOrReturnMethodsDrilldownSeries
        },
      }
    },
  }
}
</script>

<style>

</style>
